import React from 'react';
import { createBrowserRouter, RouteObject, RouterProvider } from 'react-router-dom';
import RootLayout from '../views/RootLayout';
import {App} from '../App';
import Home from '../components/pages/Home';
import WorkspaceDetails from '../components/pages/WorkspaceDetails';
import Workspaces from '../components/pages/Workspaces';
import Privileges from '../components/pages/Privileges';
import AddEditPrivilege from '../components/pages/AddEditPrivilege';
import Users from '../components/pages/Users';
import UserRoles from '../components/pages/UserRoles';
import AddEditUserRoles from '../components/pages/AddEditUserRoles';
import Groups from '../components/pages/Groups';
import AddEditUserGroups from '../components/pages/AddEditUserGroups';
import AddEditUser from '../components/pages/AddEditUser';
import Approvals from '../components/pages/Approvals';
import ApprovalsUpdate from '../components/pages/ApprovalsUpdate';
import AdminTrainings from '../components/pages/AdminTrainings';
// import RequireAdmin from "../helpers/RequireAdmin"
import { useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

export const MenuItemsContext = React.createContext({});

const RequireAdmin = ({ children }) => {
  const { userDetails } = useSelector((state: any) => state.user); // Adjust this to match your state structure
  if (userDetails?.isAdmin !== true) {
    // If the user is not an admin, redirect them to the home page or a not-authorized page
    return <Navigate to="/" replace />;
  }
  return children;
};

export function Router() {

  const routes: RouteObject[] = [
    {
      element: <App />,
      children: [
        {
          path: '/',
          element: <RootLayout />,
          children: [
            {
              path: "/",
              element: <Home />
            },
            {
              path: "/workspace",
              element: <Workspaces />,
            },
            {
              path: "/workspace/:workspaceId/:chatId",
              element: <WorkspaceDetails />
            },
            {
              path: "/privileges",
              element: <RequireAdmin><Privileges /></RequireAdmin>,
            },
            {
              path: "/privileges/add",
              element: <RequireAdmin><AddEditPrivilege /></RequireAdmin>
            },
            {
              path: "/privileges/edit/:privilegeId",
              element: <RequireAdmin><AddEditPrivilege /></RequireAdmin>,
            },
            {
              path: "/admin/user-roles",
              element: <RequireAdmin><UserRoles /></RequireAdmin>,
            },
            {
              path: "/admin/user-roles/add",
              element: <RequireAdmin><AddEditUserRoles /></RequireAdmin>,
            },
            {
              path: "/admin/user-roles/edit/:userRoleId",
              element: <RequireAdmin><AddEditUserRoles /></RequireAdmin>,
            },
            {
              path: "/admin/users",
              element: <RequireAdmin><Users /></RequireAdmin>,
            },
            {
              path: "/admin/users/add",
              element: <RequireAdmin><AddEditUser /></RequireAdmin>,
            },
            {
              path: "/admin/users/edit/:userId",
              element: <RequireAdmin><AddEditUser /></RequireAdmin>,
            },
            {
              path: "/admin/user-groups",
              element: <RequireAdmin><Groups /></RequireAdmin>,
            },
            {
              path: "/admin/user-groups/edit/:groupId",
              element: <RequireAdmin><AddEditUserGroups /></RequireAdmin>,
            },
            {
              path: "/admin/user-groups/add",
              element: <RequireAdmin><AddEditUserGroups /></RequireAdmin>,
            },
            {
              path: "/admin/approvals",
              element: <RequireAdmin><Approvals /></RequireAdmin>,
            },
            {
              path: "/admin/approvals/:workspaceId",
              element: <RequireAdmin><ApprovalsUpdate /></RequireAdmin>,
            },
            {
              path: "/admin/trainings",
              element: <RequireAdmin><AdminTrainings /></RequireAdmin>,
            },
          ]
        }
      ]
    }
  ];

  const browserRouter = createBrowserRouter(routes);

  return (
     <>
        <RouterProvider router={browserRouter} />
     </>
  );
}